"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Requester = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _replacer = require("./replacer");

function encodeValue(value) {
  return value == null || typeof value === "function" ? "" : encodeURIComponent(value);
}

function buildQueryString(qs) {
  return Object.keys(qs).reduce(function (acc, key) {
    var encodedKey = encodeURIComponent(key);
    var str = '';

    if (Array.isArray(qs[key])) {
      str = qs[key].reduce(function (acc, val) {
        var encodedVal = encodeValue(val);

        if (encodedVal != null && encodedVal !== '') {
          acc += "&" + encodedKey + "=" + encodedVal;
        }

        return acc;
      }, '');
    } else {
      var encodedVal = encodeValue(qs[key]);

      if (encodedVal != null && encodedVal !== '') {
        str = "&" + encodedKey + "=" + encodedVal;
      }
    }

    return acc + str;
  }, '').replace(/^&/, '');
}

var Requester = exports.Requester = {
  _meta: function _meta(xhr) {
    return {
      status: xhr.status,
      error: xhr.statusText
    };
  },
  authToken: function authToken(token) {
    return token ? {
      Authorization: "Token token=\"" + token + "\""
    } : {};
  },
  $callFn: function $callFn(_ref, conditions) {
    var token = _ref.token,
        host = _ref.host,
        hooks = _ref.hooks;
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _this = this;

    var successCallback = arguments[3];
    var failCallback = arguments[4];
    var actionParams = settings.actionParams,
        _settings$callOptions = settings.callOptions,
        callOptions = _settings$callOptions === undefined ? {} : _settings$callOptions;

    var path = _replacer.Replacer.replaceConditions(actionParams.path, conditions);

    var url = host + "/api/" + path;

    var _hooks$beforeSend = hooks.beforeSend({
      qs: callOptions.qs || {},
      headers: _extends({}, this.authToken(token)),
      data: callOptions.data || {}
    }),
        qs = _hooks$beforeSend.qs,
        headers = _hooks$beforeSend.headers,
        data = _hooks$beforeSend.data;

    delete callOptions.qs;

    var ajaxOptions = _extends({
      method: actionParams.method,
      contentType: 'application/json',
      headers: headers,
      url: url + "?" + $.param(qs)
    }, callOptions, {
      data: JSON.stringify(data)
    });

    var defer = $.Deferred();
    $.ajax(ajaxOptions).done(function (data, textStatus, xhr) {
      if (xhr.status >= 200 && xhr.status <= 299) {
        defer.resolve(successCallback(_this._meta(xhr), data));
      } else {
        defer.reject(failCallback(new Error("Server " + ajaxOptions.url + " responded with " + xhr.status + ": " + xhr.statusText), xhr));
      }
    }).fail(function (xhr) {
      defer.reject(failCallback(new Error("Server " + ajaxOptions.url + " responded with " + xhr.status + ": " + xhr.statusText), xhr));
    });
    return defer;
  },
  callFn: function callFn(_ref2, conditions) {
    var token = _ref2.token,
        host = _ref2.host,
        hooks = _ref2.hooks;
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _this2 = this;

    var successCallback = arguments[3];
    var failCallback = arguments[4];
    var actionParams = settings.actionParams,
        _settings$callOptions2 = settings.callOptions,
        callOptions = _settings$callOptions2 === undefined ? {} : _settings$callOptions2;

    var path = _replacer.Replacer.replaceConditions(actionParams.path, conditions);

    var url = host + "/api/" + path;

    var baseHeaders = _extends({
      'Content-Type': 'application/json'
    }, this.authToken(token));

    var _hooks$beforeSend2 = hooks.beforeSend({
      qs: callOptions.qs || {},
      headers: baseHeaders,
      data: callOptions.data || {}
    }),
        qs = _hooks$beforeSend2.qs,
        headers = _hooks$beforeSend2.headers,
        data = _hooks$beforeSend2.data;

    var opts = {
      method: actionParams.method,
      headers: new Headers(headers)
    };
    url += "?" + buildQueryString(qs);
    var body = JSON.stringify(data);

    if (body !== "{}") {
      if (opts.method === 'GET') {
        url += "&" + buildQueryString(data);
      } else {
        opts.body = body;
      }
    }

    return new Promise(function (resolve, reject) {
      fetch(url, opts).then(function (res) {
        if (res.ok) {
          return res.text().then(function (text) {
            if (!text || text && !text.trim()) {
              resolve(successCallback(_this2._meta(res), {}));
            } else {
              try {
                var json = JSON.parse(text);
                resolve(successCallback(_this2._meta(res), json));
              } catch (e) {
                reject(failCallback(e, res));
              }
            }
          }, function (err) {
            reject(failCallback(err, res));
          });
        }

        reject(failCallback(new Error("Server " + url + " responded with " + res.status + ": " + res.statusText), res));
      }, function (err) {
        reject(failCallback(err));
      });
    });
  },
  bindMethod: function bindMethod(actionParams, settings) {
    var _this3 = this;

    if (settings.usejQ) {
      return function () {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (xhr, response) {
          return response;
        };
        var failCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (error, response) {
          return {
            error: error,
            response: response
          };
        };
        return _this3.$callFn(settings, conditions, {
          actionParams: actionParams,
          callOptions: callOptions
        }, successCallback, failCallback);
      };
    } else {
      return function () {
        var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (xhr, response) {
          return response;
        };
        var failCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (error, response) {
          return {
            error: error,
            response: response
          };
        };
        return _this3.callFn(settings, conditions, {
          actionParams: actionParams,
          callOptions: callOptions
        }, successCallback, failCallback);
      };
    }
  }
};